export default {
	titleHistory: 'Historique des fichiers importés',
	btnDisplayPopupUpload: 'Déposer un fichier',
	titleHistoryForPeriod: 'Historique des fichiers importés pour {period}',
	deleteDialogTitle: 'Êtes-vous sûr de vouloir supprimer ce fichier ?',
	successDeleteMessage: 'Le fichier a été supprimé avec succès',
	successAddFileMessage: 'Le fichier a été ajouté avec succès',
	errorUploadFile: 'Erreur lors de dépôts de fichier',
	addTitlePopUp: 'Dépôt de fichier',
	titleBox: 'Partage de fichiers sécurisés'
};
